import React, { Fragment as F } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import { rawMoney, rawMoneyShort, num, getPaymentRange } from 'utils'
import { getPaymentProps } from 'selectors/quoteSelectors'
import { getPaymentMods } from 'selectors/appStatusSelectors'

import './Payment.scss'

export function PaymentRange(props) {
  let {
      payment,
      mode,
      preLabel,
      label,
      paymentRangePercent,
      paymentRoundTo,
    } = props,
    [paymentStart, paymentEnd] = getPaymentRange(
      payment,
      mode === 'cash' ? 0 : paymentRoundTo,
      paymentRangePercent,
    )

  return (
    <F>
      {preLabel && <small>{preLabel}</small>}
      <strong>
        <sup className="super">$</sup>
        <span className="payment-dollars">{num(paymentStart)}</span>
        {mode !== 'cash' && !isNaN(paymentEnd) && (
          <F>
            <span className="dash">-</span>
            <sup className="super">$</sup>
            <span className="payment-dollars">{num(paymentEnd)}</span>
          </F>
        )}
      </strong>
      {label && <small>{label}</small>}
    </F>
  )
}

export function OtdPayment({ payment, preLabel, label, short }) {
  payment = (short ? rawMoneyShort : rawMoney)(payment).split('.')

  return (
    <F>
      <strong>
        {preLabel && <small>{preLabel}</small>}
        <sup className="super">$</sup>
        <span className="payment-dollars">{payment[0]}</span>
        {payment[1] && <span className="payment-cents">.{payment[1]}</span>}
      </strong>
      {label && <small>{label}</small>}
    </F>
  )
}

export function RawPayment({ payment, preLabel, label }) {
  return (
    <F>
      <strong>
        {preLabel && <small>{preLabel}</small>}
        <span className="payment-dollars">{payment}</span>
      </strong>
      {label && <small>{label}</small>}
    </F>
  )
}

export function Payment(props) {
  let {
    payment,
    dirty,
    className,
    fallback,
    mode,
    raw,
    range,
    paymentRoundTo,
  } = props

  if (!payment) return fallback || null

  let Comp = range && paymentRoundTo ? PaymentRange : OtdPayment

  if (raw) Comp = RawPayment

  return (
    <span
      className={c('quote-payment', `quote-payment-${mode}`, className, {
        'quote-payment-dirty': dirty,
      })}
    >
      <Comp {...props} />
    </span>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    ...getPaymentProps(state, op),
    ...getPaymentMods(state),
  }
}

export default connect(mapStateToProps)(Payment)
